<div class="marketing-page">
    <nav class="marketing-nav" aria-label="Product">
        <a routerLink="/" class="marketing-nav-link">Spectyra home</a>
        <span class="marketing-nav-sep" aria-hidden="true">·</span>
        <span class="marketing-nav-current">OpenClaw &amp; Local Companion</span>
        <span class="marketing-nav-sep" aria-hidden="true">·</span>
        <a routerLink="/in-app" class="marketing-nav-link">In-app integration</a>
    </nav>

    <div class="home-container">
        <div class="hero-section">
            <h1>Spectyra for OpenClaw</h1>
            <p class="tagline">Local companion, live token savings, <code class="inline-code">spectyra/*</code> models</p>

            <p class="description">
                Run Spectyra next to OpenClaw: optimize LLM traffic through a small process on your machine,
                then watch estimated savings in real time on the local dashboard. Install the skill from
                <a href="https://clawhub.ai/immrlucky/spectyra" target="_blank" rel="noopener noreferrer" class="hero-link">ClawHub</a>,
                then install and start the Local Companion.
            </p>

            <div class="install-block">
                <p class="install-label">Install and start the Local Companion</p>
                <pre class="install-command">npm install -g &#64;spectyra/local-companion&#64;latest &amp;&amp; spectyra-companion start --open</pre>
                <p class="dashboard-hint">
                    After it starts, open the <strong>real-time savings</strong> dashboard:
                    <a href="http://127.0.0.1:4111/dashboard" target="_blank" rel="noopener noreferrer" class="hero-link">http://127.0.0.1:4111/dashboard</a>
                </p>
            </div>

            <div class="cta-buttons">
                <a href="https://clawhub.ai/immrlucky/spectyra" target="_blank" rel="noopener noreferrer" class="btn btn-primary">View skill on ClawHub</a>
                <a routerLink="/contact" class="btn btn-tertiary">Contact</a>
            </div>
        </div>

        <div class="features-section">
            <h2>Built for OpenClaw right now</h2>
            <div class="features-grid">
                <div class="feature-card">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <h3>ClawHub skill</h3>
                    <p>
                        Install the published skill from ClawHub so OpenClaw picks up <code class="inline-code">spectyra/smart</code>
                        and the companion install path documented in <code class="inline-code">SKILL.md</code>.
                    </p>
                </div>
                <div class="feature-card">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M3 3V21H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7 16L12 11L16 15L21 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <h3>Real-time savings</h3>
                    <p>
                        The Local Companion serves a dashboard on <code class="inline-code">127.0.0.1:4111</code> so you can see
                        token and cost savings as you use OpenClaw—no separate billing flow required for local use.
                    </p>
                </div>
                <div class="feature-card">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                            <path d="M7 11V7C7 4.79086 8.79086 3 11 3H13C15.2091 3 17 4.79086 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </div>
                    <h3>Local-first</h3>
                    <p>
                        Model traffic is optimized on your machine; your LLM provider credentials stay in your Local Companion
                        configuration—not sent to Spectyra for inference.
                    </p>
                </div>
            </div>
        </div>

        <div class="how-it-works">
            <h2>How it works with OpenClaw</h2>
            <div class="steps">
                <div class="step">
                    <div class="step-number">1</div>
                    <h3>Install the skill</h3>
                    <p>On ClawHub, open the Spectyra skill and follow <code class="inline-code">openclaw skills install spectyra</code> (or your OpenClaw UI) so config points at the companion.</p>
                </div>
                <div class="step">
                    <div class="step-number">2</div>
                    <h3>Run the companion</h3>
                    <p>
                        <code class="inline-code">npm install -g &#64;spectyra/local-companion&#64;latest &amp;&amp; spectyra-companion start --open</code>
                    </p>
                </div>
                <div class="step">
                    <div class="step-number">3</div>
                    <h3>Open the dashboard</h3>
                    <p>
                        Use <a href="http://127.0.0.1:4111/dashboard" target="_blank" rel="noopener noreferrer" class="text-link">http://127.0.0.1:4111/dashboard</a>
                        for live savings while you chat with OpenClaw.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
